//natives
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

//components
import Table from "../../../../../../../../../../../util/Table/.mixins/Table";
import Alerta from "../../../../../../../../../../../util/snackbars/.mixins/";

//css
import FornecedoresListaCss from './FornecedoresLista-css';
const useStyles = FornecedoresListaCss();

export default function Content(props) {
    const classes = useStyles();
    
    return (
        <div className={classes.externalDiv}>

            {props.state.isLoading &&
            <div align="center">
                <CircularProgress />
            </div>
            }
            {!props.state.isLoading &&
            <div>
                <Table {...props} className={classes.root}/>
                <Alerta ref={props.props.child}/>
            </div>
            }

        </div>
    );
}